import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/es';
export const locale = {
  lang: 'es',
  data: {
    'CONSULTA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
        'PRODUCTOS': catalogos.productos,
      },
      'TITULO': 'Calendario encuestas',
      'SUBTITULO': 'Consulte la información de las encuestas generadas en la plataforma en un rango específico',
      'TXT_RANG_DAT':'Introduzca un rango de fechas',
      'BTN_CANC':'Cancelar',
      'BTN_APLI':'Aplicar',
      'MOD_TITT_INFO':'Información de encuesta',
      'TXT_NAM_COMPA':'Nombre empresa:  ',
      'TXT_NAM_TOKEN':'Survey token:  ',
      'TXT_DAT_LAN':'Fecha lanzamiento:  ',
      'TXT_DAT_CLOS':'Fecha cierre:  ',
      'TXT_SUR_STA':'Estaus encuesta:  ',
      'TXT_TIP_SUR':'Tipo producto:  ',
      'TXT_YEA_SUR':'Año encuesta:  ',
      'ESTATUS':{
        '0':'Inactiva',
        '1':'Activa',
        '2':'Cerrada',
      },
      'CAMPOS': {
        'broker': 'Broker',
      },
    }
  }
};
